
import React, { useState, useRef, useEffect } from 'react';
import { THERAPISTS } from '../components/data/services';
// import WarReliefPopup from '../components/utilities/WarReliefPopup';

const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxVHVbRaJCCXoxxzuyDhFyS6jNh7t_ow36wwVIQYt4RBFozof6ZgTfgaAOA38Gca4xV/exec'

//const site_key = '6LcbTw4rAAAAALsKqwFeAGel5XQ7At0MBgkDhMpr'
// secret key = 6LcbTw4rAAAAAJpP0kdEwT8T04Ohu2QOQ6MED4Zc

const BookAppointment: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const totalSteps = 15; // Fixed: should be 15, not 14

  const [recaptchaToken, setRecaptchaToken] = useState('');
  console.log(setRecaptchaToken);

  const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: '',
    pronouns: '',
    email: '',
    whatsapp: '',
    daysAvailable: [] as string[],
    timingsAvailable: '',
    therapyModeLocation: {
      mode: '',
      city: '',
      area: ''
    },
    concern: '',
    probonoEligibility: false,
    priceRange: '',
    therapistPreferences: '',
    selectedTherapist: '',
    referralSource: '',
    socialMediaPlatform: '',
    otherReferralSource: '',
    contactConsent: false,
  });
  useEffect(() => {
    const timer = setTimeout(() => {
      const activeInput = document.querySelector('input:not([type="checkbox"]):not([type="radio"]), textarea, select');
      if (activeInput && 'focus' in activeInput) {
        (activeInput as HTMLElement).focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [currentStep]);


  const priceRangeOptions = [
    "0-500",
    "500-1000",
    "1000-1500",
    "1500-2000",
    "2000+"
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;

    // Special handling for therapyModeLocation fields
    if (name === 'therapyModeLocationMode' || name === 'therapyModeLocationCity' || name === 'therapyModeLocationArea') {
      setFormData(prevData => ({
        ...prevData,
        therapyModeLocation: {
          ...prevData.therapyModeLocation,
          ...(name === 'therapyModeLocationMode' && { mode: value }),
          ...(name === 'therapyModeLocationCity' && { city: value }),
          ...(name === 'therapyModeLocationArea' && { area: value })
        }
      }));
      return;
    }

    if (name === 'daysAvailable' && type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      const dayValue = value;

      setFormData(prevData => {
        if (checked) {
          // Add the day if checked
          return {
            ...prevData,
            daysAvailable: [...prevData.daysAvailable, dayValue]
          };
        } else {
          // Remove the day if unchecked
          return {
            ...prevData,
            daysAvailable: prevData.daysAvailable.filter(day => day !== dayValue)
          };
        }
      });
    } else {
      // Handle other form fields normally
      const newValue = type === 'checkbox' ? (e.target as HTMLInputElement).checked : value;
      setFormData(prevData => ({
        ...prevData,
        [name]: newValue
      }));
    }
  };

  const nextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, totalSteps));
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  // Fixed validation logic
  const canProceedToNextStep = () => {
    switch (currentStep) {
      case 1:
        return formData.name.trim() !== '';
      case 2:
        return formData.age.trim() !== '';
      case 3:
        return formData.gender.trim() !== '';
      case 4: 
        return formData.pronouns.trim() !== '';
      case 5:
        return formData.email.trim() !== '';
      case 6:
        return formData.whatsapp.trim() !== '';
      case 7:
        return formData.daysAvailable.length > 0;
      case 8:
        return formData.timingsAvailable.trim() !== '';
      case 9:
        if (formData.therapyModeLocation.mode === 'Offline') {
          return (
            formData.therapyModeLocation.mode.trim() !== '' &&
            formData.therapyModeLocation.city.trim() !== '' &&
            formData.therapyModeLocation.area.trim() !== ''
          );
        } else {
          return formData.therapyModeLocation.mode.trim() !== '';
        }
      case 10:
        return formData.concern.trim() !== '';
      case 11:
        // Check if price range is selected and if pro-bono, then eligibility must be checked
        return formData.priceRange !== '' &&
          (formData.priceRange !== "Pro-bono (2 initial sessions subject to therapist availability)" || formData.probonoEligibility);
      case 12:
        return formData.referralSource !== '' &&
          (formData.referralSource !== "Social Media" || formData.socialMediaPlatform !== '') &&
          (formData.referralSource !== "Other" || formData.otherReferralSource !== '');
      case 13:
        return true; // therapistPreferences is optional
      case 14:
        return true; // selectedTherapist is optional
      case 15:
        return formData.contactConsent;
      default:
        return true;
    }
  };

  const submitToGoogleSheets = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.contactConsent) {
      alert("Please agree to be contacted by our team.");
      return;
    }

    if (formData.daysAvailable.length === 0) {
      alert("Please select at least one day when you're available.");
      return;
    }

    if (formData.priceRange === "Pro-bono (2 initial sessions subject to therapist availability)" && !formData.probonoEligibility) {
      alert("Please confirm your eligibility for pro-bono therapy.");
      return;
    }

    // Combine therapyModeLocation for submission
    let therapyModeLocationString = formData.therapyModeLocation.mode;
    if (formData.therapyModeLocation.mode === 'Offline') {
      therapyModeLocationString += ` - ${formData.therapyModeLocation.city}, ${formData.therapyModeLocation.area}`;
    }

    console.log("Form data being sent:", formData);
    console.log("Price Range:", formData.priceRange);
    console.log("Therapy Mode Location:", therapyModeLocationString);

    setIsSubmitting(true);
    setIsLoading(true);

    try {
      // get IP address 
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();

      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          timeStamp: new Date().toISOString(),
          ipAddress: ipData.ip,
          ...formData,
          daysAvailable: formData.daysAvailable.join(", "),
          therapyModeLocation: therapyModeLocationString,
          recaptchaToken
        })
      });
      console.log("Response : ", response);
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSubmitSuccess(true);
      // sendWhatsAppMessage();

      setFormData({
        name: '',
        age: '',
        gender: '',
        pronouns: '',
        email: '',
        whatsapp: '',
        daysAvailable: [] as string[],
        timingsAvailable: '',
        therapyModeLocation: {
          mode: '',
          city: '',
          area: ''
        },
        concern: '',
        probonoEligibility: false,
        priceRange: '',
        therapistPreferences: '',
        selectedTherapist: '',
        referralSource: '',
        socialMediaPlatform: '',
        otherReferralSource: '',
        contactConsent: false,
      });
    } catch (error) {
      console.error('Error submitting form: ', error);
      alert('There was an error submitting the form. PLEASE TRY AGAIN');
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };


  const DaysAvailableDropdown = ({ formData, setFormData }: {
    formData: { daysAvailable: string[] },
    setFormData: React.Dispatch<React.SetStateAction<any>>
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const daysOfWeek = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    // Close dropdown on Escape key
    useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          setIsOpen(false);
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, []);

    const handleDayToggle = (day: string) => {
      setFormData((prev: any) => ({
        ...prev,
        daysAvailable: prev.daysAvailable.includes(day)
          ? prev.daysAvailable.filter((d: string) => d !== day)
          : [...prev.daysAvailable, day]
      }));
    };

    const getDisplayText = () => {
      if (formData.daysAvailable.length === 0) {
        return "Select days available";
      }
      if (formData.daysAvailable.length === 1) {
        return formData.daysAvailable[0];
      }
      if (formData.daysAvailable.length === 7) {
        return "All days selected";
      }
      return `${formData.daysAvailable.length} days selected`;
    };

    const clearAllDays = () => {
      setFormData((prev: any) => ({ ...prev, daysAvailable: [] }));
    };

    const selectAllDays = () => {
      setFormData((prev: any) => ({ ...prev, daysAvailable: [...daysOfWeek] }));
    };

    return (
      <div className="relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="mt-1 w-full flex items-center justify-between border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
          focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
          transition-all duration-300 ease-in-out
          hover:border-teal-300 hover:bg-white
          text-left"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          <span className={formData.daysAvailable.length === 0 ? 'text-gray-400' : 'text-gray-900'}>
            {getDisplayText()}
          </span>
          <svg
            className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {isOpen && (
          <div className="relative  w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-auto">
            {/* Select All / Clear All buttons */}
            <div className="border-b border-gray-100 px-4 py-2 bg-gray-50 flex justify-between">
              <button
                type="button"
                onClick={selectAllDays}
                className="text-sm text-teal-600 hover:text-teal-700 font-medium"
                disabled={formData.daysAvailable.length === 7}
              >
                Select All
              </button>
              <button
                type="button"
                onClick={clearAllDays}
                className="text-sm text-red-600 hover:text-red-700 font-medium"
                disabled={formData.daysAvailable.length === 0}
              >
                Clear All
              </button>
            </div>

            <div className="py-2">
              {daysOfWeek.map(day => (
                <label
                  key={day}
                  className="flex items-center px-4 py-3 hover:bg-teal-50 cursor-pointer transition-colors duration-150"
                >
                  <input
                    type="checkbox"
                    checked={formData.daysAvailable.includes(day)}
                    onChange={() => handleDayToggle(day)}
                    className="w-4 h-4 text-teal-600 bg-gray-100 border-gray-300 rounded focus:ring-teal-500 focus:ring-2"
                  />
                  <span className="ml-3 text-gray-900 font-medium">{day}</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {/* Selected days preview */}
        {formData.daysAvailable.length > 0 && (
          <div className="mt-3">
            <div className="text-sm text-gray-600 mb-2">Selected days:</div>
            <div className="flex flex-wrap gap-2">
              {formData.daysAvailable.map(day => (
                <span
                  key={day}
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-800"
                >
                  {day}
                  <button
                    type="button"
                    onClick={() => handleDayToggle(day)}
                    className="ml-2 inline-flex items-center justify-center w-4 h-4 rounded-full hover:bg-teal-200 transition-colors"
                    aria-label={`Remove ${day}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };


  const LoadingOverlay = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin">
          <svg
            className="w-20 h-20 text-teal-400"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <p className="mt-4 text-xl text-white">Submitting Your Request...</p>
      </div>
    </div>
  );

  const renderFormStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-teal-700"> Name/Initials  </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"
            />
          </div>
        )
      case 2:
        return (
          <div>
            <label htmlFor="age" className="block text-sm font-medium text-teal-700">
              Age
            </label>
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"
            />
          </div>
        )
      case 3:
        return (
          <div>
            <label htmlFor="gender" className="block text-sm font-medium text-teal-700">
              Gender you identify with
            </label>
            <input
              type="text"
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"

              placeholder="Please specify your gender identity"
            />
          </div>
        )
      case 4: 
      return (
        <div>
          <label htmlFor="pronouns" className="block text-sm font-medium text-teal-700"> Pronouns  </label>
          <input
            type="text"
            id="pronouns"
            name="pronouns"
            value={formData.pronouns}
            onChange={handleChange}
            autoFocus={true}
            required
            className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
transition-all duration-300 ease-in-out
hover:border-teal-300 hover:bg-white
placeholder-gray-400"
          />
          </div>
      )

      case 5:
        return (
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-teal-700">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"

            />
          </div>
        )

      case 6:
        return (
          <div>
            <label htmlFor="whatsapp" className="block text-sm font-medium text-teal-700">
              WhatsApp Number
            </label>
            <input
              type="tel"
              id="whatsapp"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"

            />
          </div>
        )
      case 7:
        return (
          <div>
            <label className="block text-sm font-medium text-teal-700 mb-2">
              Days Available
            </label>
            <DaysAvailableDropdown formData={formData} setFormData={setFormData} />
          </div>
        )

      case 8:
        return (
          <div>
            <label htmlFor="timingsAvailable" className="block text-sm font-medium text-teal-700">
              Timings Available
            </label>
            <input
              type="text"
              id="timingsAvailable"
              name="timingsAvailable"
              value={formData.timingsAvailable}
              onChange={handleChange}
              autoFocus={true}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"              placeholder="Please specify your preferred timings"
            />
          </div>
        )

      case 9:
        return (
          <div>
            <label htmlFor="therapyModeLocationMode" className="block text-sm font-medium text-teal-700">
              Therapy Mode
            </label>
            <select
              id="therapyModeLocationMode"
              name="therapyModeLocationMode"
              value={formData.therapyModeLocation.mode}
              onChange={handleChange}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 \
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white\n  transition-all duration-300 ease-in-out\n  hover:border-teal-300 hover:bg-white\n  appearance-none cursor-pointer"
            >
              <option value="">Select mode</option>
              <option value="Online">Online</option>
              <option value="Offline">Offline</option>
            </select>
            {formData.therapyModeLocation.mode === 'Offline' && (
              <div className="mt-4">
                <label htmlFor="therapyModeLocationCity" className="block text-sm font-medium text-teal-700">
                  City
                </label>
                <input
                  type="text"
                  id="therapyModeLocationCity"
                  name="therapyModeLocationCity"
                  value={formData.therapyModeLocation.city}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 \
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white\n  transition-all duration-300 ease-in-out\n  hover:border-teal-300 hover:bg-white\n  placeholder-gray-400"
                  placeholder="Enter your city"
                />
                <label htmlFor="therapyModeLocationArea" className="block text-sm font-medium text-teal-700 mt-4">
                  Area
                </label>
                <input
                  type="text"
                  id="therapyModeLocationArea"
                  name="therapyModeLocationArea"
                  value={formData.therapyModeLocation.area}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 \
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white\n  transition-all duration-300 ease-in-out\n  hover:border-teal-300 hover:bg-white\n  placeholder-gray-400"
                  placeholder="Enter your area/locality"
                />
              </div>
            )}
          </div>
        )

      case 10:
        return (
          <div>
            <label htmlFor="concern" className="block text-sm font-medium text-teal-700">
              What makes you want to seek therapy?
            </label>
            <textarea
              id="concern"
              name="concern"
              rows={4}
              value={formData.concern}
              onChange={handleChange}
              required

              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400 resize-none"

              maxLength={1200}
            />
          </div>
        )

      case 11:
        return (
          <div>
            <label htmlFor="priceRange" className="block text-sm font-medium text-teal-700">
              Budget/Price Range (₹)
            </label>
            <select
              id="priceRange"
              name="priceRange"
              value={formData.priceRange}
              onChange={handleChange}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
transition-all duration-300 ease-in-out
hover:border-teal-300 hover:bg-white
appearance-none cursor-pointer"
            >
              <option value="">Select price range</option>
              <option value="Pro-bono (2 initial sessions subject to therapist availability)">Pro-bono (2 initial sessions, subject to therapist availability)</option>
              {priceRangeOptions.map(range => (
                <option key={range} value={range}>₹{range}</option>
              ))}
            </select>

            {/* Conditional content based on price range selection */}
            {formData.priceRange === "Pro-bono (2 initial sessions subject to therapist availability)" ? (
              <div className="mt-3 p-3 bg-teal-50 rounded-md border border-teal-200">
                <p className="text-sm text-teal-700 font-medium">
                  Pro-bono therapy is available for:
                </p>
                <ul className="list-disc ml-5 text-sm text-teal-700">
                  <li>College students</li>
                  <li>Currently unemployed individuals</li>
                </ul>
                <label className="flex items-start mt-2">
                  <input
                    type="checkbox"
                    name="probonoEligibility"
                    checked={formData.probonoEligibility}
                    onChange={handleChange}
                    className="mt-1 h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-teal-700">
                    I confirm that I meet the eligibility criteria for pro-bono therapy
                  </span>
                </label>
              </div>
            ) : formData.priceRange && formData.priceRange !== "" ? (
              <div className="mt-1 text-sm text-teal-600 italic">
                Note: More experienced therapists typically charge ₹1500 and above. Pricing reflects therapist experience and specialization.
              </div>
            ) : null}
          </div>
        )

      case 12:
        return (
          <div>
            <label htmlFor="referralSource" className="block text-sm font-medium text-teal-700">
              How did you hear about us?
            </label>
            <select
              id="referralSource"
              name="referralSource"
              value={formData.referralSource}
              onChange={handleChange}
              required

              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  appearance-none cursor-pointer"

            >
              <option value="">Please select an option</option>
              <option value="Social Media">Social Media</option>
              <option value="Google Search">Google Search</option>
              <option value="Friend or Family">Friend or Family Referral</option>
              <option value="Professional Referral">Professional Referral</option>
              <option value="Website">Website</option>
              <option value="Online Advertisement">Online Advertisement</option>
              <option value="Event">Event or Workshop</option>
              <option value="Other">Other</option>
            </select>
            {formData.referralSource === "Social Media" && (
              <div className="mt-2">
                <label htmlFor="socialMediaPlatform" className="block text-sm font-medium text-teal-700">
                  Which platform?
                </label>
                <select
                  id="socialMediaPlatform"
                  name="socialMediaPlatform"
                  value={formData.socialMediaPlatform}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  appearance-none cursor-pointer"
                >
                  <option value="">Select platform</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Facebook">Facebook</option>
                  <option value="X">X</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="TikTok">TikTok</option>
                  <option value="YouTube">YouTube</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            )}
            {formData.referralSource === "Other" && (
              <div className="mt-2">
                <label htmlFor="otherReferralSource" className="block text-sm font-medium text-teal-700">
                  Please specify
                </label>
                <input
                  type="text"
                  id="otherReferralSource"
                  name="otherReferralSource"
                  value={formData.otherReferralSource}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"

                />
              </div>
            )}
          </div>
        )

      case 13:
        return (
          <div>
            <label htmlFor="therapistPreferences" className="block text-sm font-medium text-teal-700">
              Therapist Preferences (Optional)
            </label>
            <textarea
              id="therapistPreferences"
              name="therapistPreferences"
              rows={2}
              value={formData.therapistPreferences}
              onChange={handleChange}
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400 resize-none"
              placeholder="Age group, gender, city, etc."
            />
          </div>
        )

      case 14:
        return (
          <div>
            <label htmlFor="selectedTherapist" className="block text-sm font-medium text-teal-700">
              Select Preferred Therapist (Optional)
            </label>
            <select
              id="selectedTherapist"
              name="selectedTherapist"
              value={formData.selectedTherapist}
              onChange={handleChange}
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  appearance-none cursor-pointer"
            >
              <option value="">No Preference</option>
              {Object.values(THERAPISTS).map(therapist => (
                <option key={therapist.id} value={therapist.name}>
                  {therapist.name}
                </option>
              ))}
            </select>
            {formData.selectedTherapist && (
              <div className="mt-2 flex items-center space-x-3">
                {Object.values(THERAPISTS)
                  .filter(t => t.name === formData.selectedTherapist)
                  .map(therapist => (
                    <div key={therapist.id} className="flex items-center">
                      <img
                        src={therapist.avatar}
                        alt={therapist.name}
                        className="w-12 h-12 rounded-full object-cover border-2 border-teal-300"
                      />
                      <span className="ml-2 text-teal-700">{therapist.name}</span>
                    </div>
                  ))
                }
              </div>
            )}
          </div>
        )

      case 15:
        return (
          <div className="flex items-start space-x-2">
            <input
              type="checkbox"
              id="contactConsent"
              name="contactConsent"
              checked={formData.contactConsent}
              onChange={handleChange}
              required
              className="mt-1 block w-full border-2 border-gray-200 rounded-xl shadow-sm p-4 bg-gray-50 text-gray-900 
  focus:ring-4 focus:ring-teal-100 focus:border-teal-400 focus:bg-white
  transition-all duration-300 ease-in-out
  hover:border-teal-300 hover:bg-white
  placeholder-gray-400"
            />
            <label htmlFor="contactConsent" className="block text-sm text-teal-700">
              I agree to be contacted by the team for further clarification and with therapist profiles
            </label>
          </div>
        )

      default:
        return null;
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50 py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Floating elements for visual interest */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-teal-200 rounded-full opacity-20 animate-pulse"></div>
      <div className="absolute top-40 right-20 w-16 h-16 bg-emerald-200 rounded-full opacity-30 animate-bounce"></div>
      <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-25 animate-pulse"></div>

      {isLoading && <LoadingOverlay />}
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mt-20 border border-gray-100 backdrop-blur-sm">
          <div className="relative">
            {/* Subtle gradient overlay */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 via-emerald-400 to-cyan-400"></div>
            <div className="bg-gradient-to-r from-teal-600 via-teal-700 to-emerald-600 py-8 px-4 sm:px-6 relative overflow-hidden">
              {/* Background pattern */}
              <div className="absolute inset-0 bg-white opacity-5">
                <div className="absolute inset-0" style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='m0 40l40-40h-40v40z'/%3E%3C/g%3E%3C/svg%3E")`,
                }}></div>
              </div>

              <div className="relative">
                <div className="text-center mb-2">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                </div>

                <h1 className="text-4xl font-bold text-white text-center font-fraunces-slab mb-2">
                  Book Your Therapy Session
                </h1>
                <p className="text-teal-100 text-center text-lg mb-6">
                  Take the first step towards better mental health
                </p>

                {/* Enhanced progress indicator */}
                <div className="flex justify-center">
                  <div className="bg-white bg-opacity-20 rounded-full p-4 backdrop-blur-sm">
                    <div className="flex items-center space-x-3">
                      <span className="text-white text-sm font-medium">Step {currentStep} of {totalSteps}</span>
                      <div className="w-40 bg-white bg-opacity-30 rounded-full h-3 relative overflow-hidden">
                        <div
                          className="bg-gradient-to-r from-white to-teal-100 h-3 rounded-full transition-all duration-500 ease-out relative"
                          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                        >
                          <div className="absolute inset-0 bg-white opacity-50 animate-pulse rounded-full"></div>
                        </div>
                      </div>
                      <span className="text-teal-100 text-sm">{Math.round((currentStep / totalSteps) * 100)}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="px-4 py-8 sm:px-6 lg:px-8">
            {submitSuccess ? (
              <div className="text-center py-12">
                <h2 className="text-2xl font-bold text-teal-700 mb-4">Thank You for Reaching Out!</h2>
                <p className="text-teal-600">
                  We've received your appointment request. Our team will contact you shortly to confirm your session.
                </p>
              </div>
            ) : (
              <form onSubmit={submitToGoogleSheets} className="space-y-6 font-work-sans">
                {renderFormStep()}

                <div className='mt-10 flex justify-between'>
                  <button
                    type='button'
                    onClick={prevStep}
                    disabled={currentStep === 1}
                    className={`px-6 py-3 rounded-lg text-base font-medium transition-all
                    ${currentStep === 1
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : 'bg-white text-teal-700 border border-teal-600 hover:bg-teal-50'}`}
                  >
                    Previous
                  </button>
                  {currentStep < totalSteps ? (
                    <button
                      type='button'
                      onClick={nextStep}
                      disabled={!canProceedToNextStep()}
                      className={`px-6 py-3 rounded-lg text-base font-medium transition-all 
                      ${!canProceedToNextStep()
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-teal-600 text-white border border-teal-600 hover:bg-teal-700 hover:text-white'}`}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      type='submit'
                      disabled={isSubmitting || !canProceedToNextStep()}
                      className={`px-6 py-3 rounded-lg text-base font-medium transition-all 
                      ${isSubmitting || !canProceedToNextStep()
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-teal-600 text-white border border-teal-600 hover:bg-teal-700 hover:text-white'}`}>
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
